import {
  Component,
  OnInit,
  AfterViewInit,
  ViewChild,
  Output,
  EventEmitter,
} from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { common } from 'src/app/app.common';
import { AppService } from 'src/app/utils/services/app.service';

@Component({
  selector: 'app-menu-sidebar',
  templateUrl: './menu-sidebar.component.html',
  styleUrls: ['./menu-sidebar.component.scss'],
})
export class MenuSidebarComponent implements OnInit, AfterViewInit {
  @ViewChild('mainSidebar', { static: false }) mainSidebar;
  @Output() mainSidebarHeight: EventEmitter<any> = new EventEmitter<any>();
  styleLi: string = 'nav-item ';
  TimKiemDonGian: any;
  TimKiemNangCao: any;
  QuaTrinhKhenThuong: any;
  QuaTrinhKyLuat: any;
  QuanLyHSSV: any;
  QuaTrinhHocTapRenLuyen: any;
  SVThoiHocNgungHoc: any;
  TongHopThiLaiHocLai: any;
  ThongKeTheoQĐ5363: any;
  ThongKeXLHKNH: any;
  ThongKeXLHDHP: any;
  TongHopNoHPKP: any;
  TongHopNoPhiLePhi: any;
  ThongTinHPLP: any;
  BaoCaoTongHopThuChi: any;
  BaoCaoTHTHC: any;
  ThongKeTheoQĐ: any;
  ThongKeTheoQuyetDinh: any;
  TraCuuCongViecGiangDay: any;
  SoLenLop: any;
  TraCuuNhanXetGiangDay: any;
  constructor(
    public appService: AppService,
    private router: Router,
    private toastr: ToastrService,
  ) { }
  com: common
  Roles:any
  ngOnInit() {
    this.com = new common(this.router);
    this.com.CheckLogin();
    var UserData = this.com.getUserinfo();
    this.Roles = UserData.Roles;
    if (this.Roles.length == 0) {
      this.toastr.warning("Bạn chưa được cấp bất kỳ quyền nào! Vui lòng liên hệ với quản trị viên để được hỗ trợ")
    } else {
      this.CreateMenu(this.Roles)
    }
  }
  menu(id: string) {
    let element, name, arr;
    element = document.getElementById(id);
    arr = element.className.split(' ');
    name = 'menu-open';
    if (arr.indexOf(name) == -1) {
      element.className += ' ' + name;
    } else {
      element.className = 'nav-item';
    }
  }
  ngAfterViewInit() {
    this.mainSidebarHeight.emit(this.mainSidebar.nativeElement.offsetHeight);
  }

  CreateMenu(dt) {
    this.TimKiemDonGian = dt.some(x => x.ID_quyen == 1101);
    this.TimKiemNangCao = dt.some(x => x.ID_quyen == 1102);
    this.QuaTrinhKhenThuong = dt.some(x => x.ID_quyen == 1103);
    this.QuaTrinhKyLuat = dt.some(x => x.ID_quyen == 1104);
    this.QuanLyHSSV = dt.some(x => x.ID_quyen == 1105);
    this.QuaTrinhHocTapRenLuyen = dt.some(x => x.ID_quyen == 1106);
    this.SVThoiHocNgungHoc = dt.some(x => x.ID_quyen == 1107);
    this.TongHopThiLaiHocLai = dt.some(x => x.ID_quyen == 1108);
    this.ThongKeTheoQuyetDinh = dt.some(x => x.ID_quyen == 1109);
    this.ThongKeXLHKNH = dt.some(x => x.ID_quyen == 1110);
    this.ThongKeXLHDHP = dt.some(x => x.ID_quyen == 1111);
    this.TongHopNoHPKP = dt.some(x => x.ID_quyen == 1112);
    this.TongHopNoPhiLePhi = dt.some(x => x.ID_quyen == 1113);
    this.ThongTinHPLP = dt.some(x => x.ID_quyen == 1114);
    this.BaoCaoTHTHC = dt.some(x => x.ID_quyen == 1115);
    this.TraCuuCongViecGiangDay = dt.some(x => x.ID_quyen == 1116);
    this.SoLenLop = dt.some(x => x.ID_quyen == 1118);
    this.TraCuuNhanXetGiangDay = dt.some(x => x.ID_quyen == 1119);
  }
}
